import { datadogRum } from '@datadog/browser-rum';
import React, { useEffect } from 'react';
import styled from 'styled-components';
import theme from '../theme';

const Wrapper = styled.div`
  background-color: var(--colors-primary-red-2);
  border-radius: 3px;
  color: var(--colors-neutral-white);
  ${theme.font.body.m}
  max-width: 315px;
  margin-left: auto;
  margin-right: auto;
  padding: 10px;
  text-align: center;
  position: relative;
  margin-bottom: 1rem;
  z-index: var(--z-index-form-error);

  &::after {
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -10px;
    content: '';
    width: 0;
    height: 0;
    border-top: solid 10px var(--colors-primary-red-2);
    border-left: solid 10px transparent;
    border-right: solid 10px transparent;
  }
`;

const getNodeText = (node: React.ReactNode): string => {
  if (node == null) return '';

  switch (typeof node) {
    case 'string':
    case 'number':
      return node.toString();

    case 'boolean':
      return '';

    case 'object': {
      if (node instanceof Array) return node.map(getNodeText).join('');

      if ('props' in node) return getNodeText(node.props.children);
    }

    default:
      return '';
  }
};

interface FormErrorProps {
  children: React.ReactNode;
}

const FormError: React.FC<FormErrorProps> = ({ children, ...rest }) => {
  useEffect(() => {
    const text = getNodeText(children);
    datadogRum.addError(new Error(text), {
      customType: 'formError'
    });
  }, [children]);

  return <Wrapper {...rest}>{children}</Wrapper>;
};

export default FormError;
